module.exports = __webpack_public_path__ + "img/loading.76d77891.gif";